import React from 'react';
import { createUseStyles } from 'react-jss';
import { isMobile } from 'react-device-detect';
import { eventTypes } from '../notificationConstants';

import { TimeAndBadgeComponent } from './common';
import { useTranslation } from 'react-i18next';

const useStyle = createUseStyles({
  notificationBodyTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTextStyle: {
    color: '#111',
    fontSize: '12px',
    fontWeight: 600,
  },
  userName: {
    color: '#666',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 400,
  },
});
const CreateHeaderForNotificationBody = (props: any) => {
  const { t } = useTranslation();
  const { item, entityIdPrettyName, classes, extraData } = props;
  switch (item) {
    case 'issue_comment':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('added a')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{t('Comment')} </span>
          {entityIdPrettyName && (
            <>
              {t('on')}{' '}
              <span className={classes.headerTextStyle}>
                {entityIdPrettyName}
              </span>
            </>
          )}
        </span>
      );
    case 'issue_status_changed':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('changed_the')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{t('Status')} </span>
          {entityIdPrettyName && (
            <>
              {t('of')}{' '}
              <span className={classes.headerTextStyle}>
                {entityIdPrettyName}
              </span>
            </>
          )}
        </span>
      );
      case 'issue_custom_property_changed':
        return (
          <span>
            <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
              {' '}
              {t('updated')}{' '}
            </span>
            <span className={classes.headerTextStyle}>
              {extraData?.message?.split(',')[0]}
            </span>
            <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
              {' '}
              with{' '}
            </span>
            <span className={classes.headerTextStyle}>
              {extraData?.message?.split(',')[1]}
            </span>
          </span>
        );
    case 'issue_assignee_added':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('New ticket assigned to you')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
        </span>
      );
    case 'issue_assignee_removed':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('Your Ticket')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('has been unassigned')}
          </span>
        </span>
      );
    default:
      return null;
  }
};
export const CreateTitleForNotificationBody = (props: any) => {
  const classes = useStyle();
  const {
    item,
    ticketName,
    sourceName,
    notificationId,
    notificationStatus,
    setNotificationStatus,
  } = props;
  return (
    <div className={classes.notificationBodyTitle}>
      <div>
        <span className={classes.userName}>{item.actionUser.userName}</span>
        <CreateHeaderForNotificationBody
          item={eventTypes?.[sourceName]?.[item?.eventType]}
          entityIdPrettyName={ticketName}
          classes={classes}
          extraData={item?.extraData}
        />
      </div>
      {!isMobile && (
        <TimeAndBadgeComponent
          item={item}
          notificationId={notificationId}
          notificationStatus={notificationStatus}
          setNotificationStatus={setNotificationStatus}
        />
      )}
    </div>
  );
};
